'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (StickyContent, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.StickyContent = $('[data-sticky-content]');
			$dom.StickyContentContainer = $('[data-sticky-content-container]');
		};

		var StickyContentInit = function StickyContentInit() {
			if ($dom.StickyContent.length > 0 && $dom.StickyContentContainer.length > 0) {
				var offset = 110;

				var containerHeight = $dom.StickyContentContainer.outerHeight();
				var containerOffset = $dom.StickyContentContainer.offset().top - offset;
				var containerOffsetBottom = $dom.StickyContentContainer.offset().top + containerHeight;

				var contentHeight = $dom.StickyContent.outerHeight();
				var contentOffset = $dom.StickyContent.offset().top - offset;

				var animationEnd = containerOffsetBottom - contentHeight - offset - 130;

				var sticky = function sticky() {
					if ($(window).width() > 640) {
						if ($(window).scrollTop() > containerOffset && $(window).scrollTop() < animationEnd) {
							var topPosition = $(window).scrollTop() - contentOffset;
							if (topPosition < 0) {
								topPosition = 0;
							}
							$dom.StickyContent.css('top', topPosition);
						} else if ($(window).scrollTop() >= animationEnd) {
							var topPosition = animationEnd - contentOffset;
							$dom.StickyContent.css('top', topPosition);
						} else {
							$dom.StickyContent.css('top', 0);
						}
					}
				};
				sticky();
				$(window).on('scroll', function () {
					sticky();
				});
			}
		};

		StickyContent.init = function () {
			cacheDom();
			$(window).on('load', function () {
				StickyContentInit();
			});
		};
	})(window.StickyContent = window.StickyContent || {}, _jquery2.default, undefined);
};